import { TextStyle, View, ViewStyle } from "react-native"

import { Image, ImageStyle } from "expo-image"

import { Text } from "src/components/Ignite/Text"
import { avatarImageMap } from "src/context/RiveContext"
import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

interface ConversationHeaderProps {
  sidekickName: string
  avatarId: number
  mskAvatarId?: number
  isCurrent?: boolean
  topic: string
  date: string
  contentModuleName?: string
}

export const ConversationHeader = ({
  sidekickName,
  avatarId,
  isCurrent = false,
  contentModuleName,
}: ConversationHeaderProps) => {
  const { themed } = useAppTheme()
  const avatarKey = avatarId.toString().padStart(2, "0")
  const avatarSource = avatarImageMap[avatarKey] || avatarImageMap["00"]

  const profileContainerStyle = themed([
    $profileImageContainer,
    isCurrent ? $currentAvatarContainer : $previousAvatarContainer,
  ])

  return (
    <View style={themed($container)}>
      <View style={$imagesWrapper}>
        <View style={profileContainerStyle}>
          <Image source={avatarSource} style={$profileImage} contentFit="cover" />
        </View>
      </View>
      <View style={themed($textContainer)}>
        <Text style={themed($nameText)} text={`${sidekickName}`} />
        {!!contentModuleName && (
          <Text
            style={themed($topicText)}
            text={contentModuleName}
            numberOfLines={2}
            ellipsizeMode="tail"
          />
        )}
      </View>
    </View>
  )
}

const $container: ThemedStyle<ViewStyle> = ({ colors, spacing }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  paddingHorizontal: spacing.lg,
  paddingVertical: spacing.md,
  backgroundColor: colors.background,
  width: "100%",
})

const $imagesWrapper: ViewStyle = {
  flexDirection: "row",
  alignItems: "flex-start",
  position: "relative",
  marginRight: 12,
}

const $profileImageContainer: ThemedStyle<ViewStyle> = () => ({
  width: 50,
  height: 50,
  borderRadius: 25,
  overflow: "hidden",
})

const $currentAvatarContainer: ThemedStyle<ViewStyle> = ({ colors }) => ({
  backgroundColor: colors.activeAvatarBackground,
  borderColor: colors.activeAvatarBorder,
  borderWidth: 2,
})

const $previousAvatarContainer: ThemedStyle<ViewStyle> = ({ colors }) => ({
  backgroundColor: colors.avatarBackground,
  borderColor: colors.avatarBackground,
  borderWidth: 2,
})

const $profileImage: ImageStyle = {
  width: "100%",
  height: "100%",
}

const $textContainer: ViewStyle = {
  // Removed flex: 1 to allow unit centering
}

const $nameText: ThemedStyle<TextStyle> = ({ colors, typography }) => ({
  color: colors.textDim,
  fontSize: 12,
  fontFamily: typography.fonts.figtree.normal,
})

const $topicText: ThemedStyle<TextStyle> = ({ colors, typography }) => ({
  color: colors.textDim,
  fontSize: 12,
  fontFamily: typography.fonts.figtree.normal,
  maxWidth: 250,
})
